import React from "react";
import Icon from "../assets/icons";
import { formatDate, formatDateLong } from "../utilities/functions";
import { LuClock } from "react-icons/lu";
interface TableColumn {
  header: string | React.ReactNode;
  accessor: string;
  render?: (row: any) => any;
}

interface TableRow {
  [key: string]: any;
}

interface TableProps {
  columns: TableColumn[];
  data: TableRow[];
  selectedUserId: string | null;
  currentPage?: number | null;
  onPageChange?: number | null;
  onUserClick: (id: string) => void;
  sn?: boolean;
  type?: "logs";
}

const Table: React.FC<TableProps> = ({
  columns,
  data,
  onUserClick,
  selectedUserId,
  sn = true,
  type,
}) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case "successful":
      case "active":
      case "resolved":
      case "approved":
        return "#D1FFC9";
      case "pending":
      case "suspended":
      case "closed":
      case "blocked":
      case "rejected":
        return "#FCCFCF";
      case "in_progress":
        return "#87CEEB";
      case "failed":
      case "inactive":
        return "#D9D9D9";
      default:
        return "transparent";
    }
  };

  const formatStatusText = (status: string) => {
    switch (status) {
      case "in_progress":
        return "In Progress";
      default:
        return status
          ?.replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase());
    }
  };

  const mappedData = data?.map((row: any, index) => ({
    ...row,
    serialNumber: index + 1,
  }));

  return (
    <div>
      <table className='table mt-6 w-full'>
        <thead className='bg-[#CFF0FC] h-10 rounded-md'>
          <tr className='text-xs text-left'>
            {sn && <th className='font-medium px-2'>SN.</th>}
            {columns?.map((column, index) => (
              <th className='font-medium px-2' key={index}>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className='text-[12px]'>
          {mappedData?.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              onClick={() => onUserClick(row["id"] || row["_id"])}
              className={`cursor-pointer hover:bg-gray-200 ${
                selectedUserId === (row["id"] || row["_id"])
                  ? "bg-gray-200"
                  : ""
              }`}>
              {/* Render the serial number */}
              {sn && <td className='py-2 px-2'>{row.serialNumber}</td>}
              {columns.map((column, colIndex) => (
                <td key={colIndex} className='py-2 px-2'>
                  {column.accessor === "created_at" ||
                  column.accessor === "createdAt" ? (
                    type === "logs" ? (
                      <div className='flex gap-2 items-center'>
                        <LuClock />
                        <span>{formatDateLong(row[column.accessor])}</span>
                      </div>
                    ) : (
                      formatDate(row[column.accessor])
                    )
                  ) : column.accessor === "profilePhoto" ? (
                    <img
                      src={
                        row[column.accessor] ||
                        `https://ui-avatars.com/api/?name=${
                          row["fullname"] || row["fullName"]
                        }&background=0979A1&color=fff`
                      }
                      className='rounded-full w-[40px] h-[40px]'
                      alt='profile'
                    />
                  ) : column.accessor === "id" ? (
                    <button onClick={() => onUserClick(row["id"])}>
                      <Icon name='dotIcon' />
                    </button>
                  ) : column.accessor === "_id" ? (
                    <button onClick={() => onUserClick(row["_id"])}>
                      <Icon name='dotIcon' />
                    </button>
                  ) : column.accessor === "updatedAt" ? (
                    <button onClick={() => onUserClick(row["updatedAt"])}>
                      <Icon name='deleteIcon' />
                    </button>
                  ) : column.accessor === "phone" && !row[column.accessor] ? (
                    "N/A"
                  ) : column.accessor === "status" ? (
                    <p
                      className='-mt-1 text-[12px] p-1 text-center font-normal w-20 rounded-md'
                      style={{
                        backgroundColor: getStatusColor(row[column.accessor]),
                      }}>
                      {formatStatusText(row[column.accessor])}
                    </p>
                  ) : column.accessor === "logs_user" ? (
                    <div className='flex flex-col gap-1'>
                      <p
                        className='-mt-1 text-[12px] p-1 text-center font-normal w-20 rounded-md'
                        style={{
                          backgroundColor: getStatusColor(row[column.accessor]),
                        }}>
                        {formatStatusText(row[column.accessor])}
                      </p>
                    </div>
                  ) : column.accessor === "logs_entity" ? (
                    <div className='flex flex-col gap-1'>
                      <p className='text-[12px] text-center font-semibold w-20 rounded-md'>
                        {formatStatusText(row["ticketId"])}
                      </p>
                      {formatStatusText(row["type"])}
                      <p className=''></p>
                    </div>
                  ) : column.render ? (
                    column.render(row)
                  ) : (
                    row[column.accessor]
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
